// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  connectType: 'facebook' | 'google',
  onConfirm: () => void,
  onHide: () => void,
|};

function ConfirmErasePasswordModal({ connectType, onConfirm, onHide }: Props) {
  const titleText = i18n._('Erase existing password?');
  return (
    <Modal
      accessibilityCloseLabel={i18n._('Close')}
      accessibilityModalLabel={titleText}
      onDismiss={onHide}
      heading={titleText}
      footer={
        <Box marginLeft={-1} marginRight={-1}>
          <Box padding={1}>
            <Button
              size="lg"
              text={i18n._('Cancel', 'Button text for canceling connect and erase password')}
              onClick={onHide}
            />
          </Box>
          <Box padding={1}>
            <Button
              size="lg"
              color="red"
              text={i18n._('Okay', 'Button text for accepting connect and erase password')}
              onClick={onConfirm}
            />
          </Box>
        </Box>
      }
      role="alertdialog"
    >
      <Box padding={4}>
        <Text>
          {connectType === 'google'
            ? i18n._(
                'Please confirm that you’ll log in with Google—rather than your previous Pinterest password—in the future',
              )
            : i18n._(
                'Please confirm that you’ll log in with Facebook—rather than your previous Pinterest password—in the future',
              )}
        </Text>
      </Box>
    </Modal>
  );
}

export default ConfirmErasePasswordModal;
